import { DEFAULT_CACHE_CONFIG } from 'src/services/constants';
import { MembershipEndpoints, MembershipService } from 'src/services/membership';
import useRequest from '../useRequest';
import { UseMembershipDataProps } from './useMembershipData.types';

const useMembershipData = ({ slug, enabled = true }: UseMembershipDataProps) => {
  const response = useRequest(
    MembershipEndpoints.getMembershipData(slug),
    /* istanbul ignore next */
    () => MembershipService.getMembershipData(slug),
    {
      enabled,
      ...DEFAULT_CACHE_CONFIG
    }
  );

  return {
    ...response,
    isLoading: enabled ? response.isLoading : false
  };
};

export default useMembershipData;
